import { render, staticRenderFns } from "./NoOrganizationUnitsItem.vue?vue&type=template&id=341b495c&scoped=true&"
import script from "./NoOrganizationUnitsItem.vue?vue&type=script&lang=js&"
export * from "./NoOrganizationUnitsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341b495c",
  null
  
)

export default component.exports